import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import * as api from '../../services/api';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage';
import ResearchItem from '../../components/ResearchItem';

const AllInsights = () => {
  const { t, i18n } = useTranslation();
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const breadcrumbs = [
    { labelKey: 'nav.insights', href: '/#insights' },
    { labelKey: 'insights.allInsights' }
  ];

  useEffect(() => {
    const fetchInsights = async () => {
      try {
        setLoading(true);
        const data = await api.getInsights();
        setInsights(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching insights:', err);
        setError('Failed to load insights');
      } finally {
        setLoading(false);
      }
    };

    fetchInsights();
  }, []);

  const getCurrentLang = () => {
    return i18n.language === 'zh-CN' ? 'zh_CN' : 'en_US';
  };

  const lang = getCurrentLang();

  return (
    <PageTemplate 
      titleKey="pages.allInsights.title"
      subtitleKey="pages.allInsights.subtitle"
      breadcrumbs={breadcrumbs}
    >
      {loading && <LoadingSpinner />}
      {error && <ErrorMessage message={error} />}
      
      {!loading && !error && (
        <div className="content-card">
          <h2>{t('pages.allInsights.latest')}</h2>
          <div className="insights-list">
            {insights.map((insight) => (
              <ResearchItem
                key={insight._id || insight.slug}
                title={insight.title[lang]}
                summary={insight.summary[lang]}
                author={insight.author[lang]}
                date={insight.publish_date}
                readTime={insight.read_time}
                category={insight.category}
                image={insight.cover_image}
                slug={insight.slug}
              />
            ))}
          </div>

          {insights.length === 0 && (
            <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              {t('pages.allInsights.noInsights')}
            </p>
          )}
        </div>
      )}
    </PageTemplate>
  );
};

export default AllInsights;
